import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import "./tripcheckout.css";
import API from "../../API";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from 'react-i18next';
import { jsPDF } from "jspdf";
import {
  FaUser, FaEnvelope, FaMapMarkerAlt, FaPassport, FaGlobe,
  FaMailBulk, FaArrowLeft, FaShieldAlt, FaUsers, FaChild,
  FaBaby, FaHotel, FaPlane, FaMoneyBillWave, FaChevronDown, FaChevronUp,
  FaBirthdayCake, FaVenusMars, FaIdCard, FaSignInAlt, FaUserPlus, FaTimes,
  FaCheckCircle, FaHome, FaPrint, FaReceipt, FaPhone, FaLock,
  FaEye, FaEyeSlash
} from 'react-icons/fa';

const nationalities = [
  { value: "algerian", label: "Algerian" },
  { value: "afghan", label: "Afghan" },
  { value: "albanian", label: "Albanian" },
  { value: "andorran", label: "Andorran" },
  { value: "angolan", label: "Angolan" },
  { value: "argentine", label: "Argentine" },
  { value: "armenian", label: "Armenian" },
  { value: "australian", label: "Australian" },
  { value: "austrian", label: "Austrian" },
  { value: "azerbaijani", label: "Azerbaijani" },
  { value: "bahraini", label: "Bahraini" },
  { value: "bangladeshi", label: "Bangladeshi" },
  { value: "belgian", label: "Belgian" },
  { value: "bolivian", label: "Bolivian" },
  { value: "bosnian", label: "Bosnian" },
  { value: "brazilian", label: "Brazilian" },
  { value: "british", label: "British" },
  { value: "bulgarian", label: "Bulgarian" },
  { value: "cambodian", label: "Cambodian" },
  { value: "cameroonian", label: "Cameroonian" },
  { value: "canadian", label: "Canadian" },
  { value: "chilean", label: "Chilean" },
  { value: "chinese", label: "Chinese" },
  { value: "colombian", label: "Colombian" },
  { value: "congolese", label: "Congolese" },
  { value: "croatian", label: "Croatian" },
  { value: "cuban", label: "Cuban" },
  { value: "czech", label: "Czech" },
  { value: "danish", label: "Danish" },
  { value: "dutch", label: "Dutch" },
  { value: "ecuadorian", label: "Ecuadorian" },
  { value: "egyptian", label: "Egyptian" },
  { value: "emirati", label: "Emirati" },
  { value: "estonian", label: "Estonian" },
  { value: "ethiopian", label: "Ethiopian" },
  { value: "finnish", label: "Finnish" },
  { value: "french", label: "French" },
  { value: "georgian", label: "Georgian" },
  { value: "german", label: "German" },
  { value: "ghanaian", label: "Ghanaian" },
  { value: "greek", label: "Greek" },
  { value: "hungarian", label: "Hungarian" },
  { value: "indian", label: "Indian" },
  { value: "indonesian", label: "Indonesian" },
  { value: "iranian", label: "Iranian" },
  { value: "iraqi", label: "Iraqi" },
  { value: "irish", label: "Irish" },
  { value: "italian", label: "Italian" },
  { value: "japanese", label: "Japanese" },
  { value: "jordanian", label: "Jordanian" },
  { value: "kenyan", label: "Kenyan" },
  { value: "kuwaiti", label: "Kuwaiti" },
  { value: "latvian", label: "Latvian" },
  { value: "lebanese", label: "Lebanese" },
  { value: "libyan", label: "Libyan" },
  { value: "lithuanian", label: "Lithuanian" },
  { value: "malaysian", label: "Malaysian" },
  { value: "mexican", label: "Mexican" },
  { value: "moroccan", label: "Moroccan" },
  { value: "nigerian", label: "Nigerian" },
  { value: "norwegian", label: "Norwegian" },
  { value: "omani", label: "Omani" },
  { value: "pakistani", label: "Pakistani" },
  { value: "Palestinian", label: "Palestinian" },
  { value: "peruvian", label: "Peruvian" },
  { value: "philippine", label: "Philippine" },
  { value: "polish", label: "Polish" },
  { value: "portuguese", label: "Portuguese" },
  { value: "qatari", label: "Qatari" },
  { value: "romanian", label: "Romanian" },
  { value: "russian", label: "Russian" },
  { value: "saudi", label: "Saudi" },
  { value: "senegalese", label: "Senegalese" },
  { value: "serbian", label: "Serbian" },
  { value: "singaporean", label: "Singaporean" },
  { value: "somali", label: "Somali" },
  { value: "south_african", label: "South African" },
  { value: "south_korean", label: "South Korean" },
  { value: "spanish", label: "Spanish" },
  { value: "sudanese", label: "Sudanese" },
  { value: "swedish", label: "Swedish" },
  { value: "swiss", label: "Swiss" },
  { value: "syrian", label: "Syrian" },
  { value: "thai", label: "Thai" },
  { value: "tunisian", label: "Tunisian" },
  { value: "turkish", label: "Turkish" },
  { value: "ukrainian", label: "Ukrainian" },
  { value: "american", label: "American" },
  { value: "venezuelan", label: "Venezuelan" },
  { value: "vietnamese", label: "Vietnamese" },
  { value: "yemeni", label: "Yemeni" },
  { value: "zambian", label: "Zambian" },
  { value: "zimbabwean", label: "Zimbabwean" },
];

const genderOptions = [
  { value: "male", label: "Homme" },
  { value: "female", label: "Femme" },
];

const documentTypes = [
  { value: "passport", label: "Passeport" },
  { value: "id_card", label: "Carte d'identit\u00e9" },
];

const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '42px',
    height: '42px',
    borderRadius: '10px',
    border: state.isFocused ? '2px solid #e8651a' : '2px solid #e8e8e8',
    boxShadow: 'none',
    fontSize: '0.95rem',
    '&:hover': { borderColor: '#e8651a' },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 12px',
    height: '38px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '38px',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 10,
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#e8651a' : state.isFocused ? '#fff3ec' : '#fff',
    color: state.isSelected ? '#fff' : '#333',
    fontSize: '0.95rem',
    padding: '8px 12px',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#aaa',
  }),
};

const createEmptyGuest = (type) => ({
  firstname: "",
  lastname: "",
  birthday: "",
  gender: "",
  documentType: "passport",
  documentNumber: "",
  nationality: "",
  type,
});

export default function TripCheckout({ voya, place, adult, children, total, bebe, voyage_id, onBack, onComplete, depart, arrivage }) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const checkinDate = depart ? new Date(depart).toISOString() : "";
  const checkoutDate = arrivage ? new Date(arrivage).toISOString() : "";

  // Build initial guests array
  const buildInitialGuests = () => {
    const guests = [];
    for (let i = 0; i < adult; i++) guests.push(createEmptyGuest("ADULT"));
    for (let i = 0; i < children; i++) guests.push(createEmptyGuest("CHILD"));
    for (let i = 0; i < bebe; i++) guests.push(createEmptyGuest("BABY"));
    return guests;
  };

  const [guests, setGuests] = useState(buildInitialGuests);
  const [expandedGuest, setExpandedGuest] = useState(0);

  const [contactData, setContactData] = useState({
    email: "",
    street: "",
    code_postal: "",
    acceptedTerms: false,
  });

  const [errors, setErrors] = useState({});
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [modalView, setModalView] = useState("login"); // "login" or "register"
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [loginError, setLoginError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [registerData, setRegisterData] = useState({ firstname: "", lastname: "", phone: "", email: "", password: "" });
  const [registerError, setRegisterError] = useState("");
  const [registerLoading, setRegisterLoading] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);
  const [isAuthed, setIsAuthed] = useState(!!localStorage.getItem("protoken"));
  const [pendingPayment, setPendingPayment] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const navigate = useNavigate();

  // Block form access on mount if not authenticated
  useEffect(() => {
    if (!isAuthed) {
      setModalView("login");
      setLoginError("");
      setRegisterError("");
      setShowLoginPrompt(true);
    }
  }, [isAuthed]);

  const notifySuccess = () =>
    toast.success(t("checkoutvol.reservation_success"), {
      position: "top-right",
      autoClose: 3000,
    });

  const notifyLoginRequired = () =>
    toast.error(t("checkoutvol.login_required"), {
      position: "top-right",
      autoClose: 3000,
    });

  const notifyError = (message) =>
    toast.error(`${t("checkoutvol.error")}: ${message}`, {
      position: "top-right",
      autoClose: 5000,
    });

  const updateGuest = (index, field, value) => {
    setGuests(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
    setErrors(prev => ({ ...prev, [`guest_${index}_${field}`]: null }));
  };

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: null }));
  };

  const toggleGuest = (index) => {
    setExpandedGuest(expandedGuest === index ? -1 : index);
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate first adult (booker)
    if (!guests[0]?.firstname) newErrors.guest_0_firstname = t("checkoutvol.required_field_error");
    if (!guests[0]?.lastname) newErrors.guest_0_lastname = t("checkoutvol.required_field_error");
    if (!guests[0]?.documentNumber) {
      newErrors.guest_0_documentNumber = t("checkoutvol.required_field_error");
    } else {
      const doc0 = String(guests[0].documentNumber).trim();
      const isPassport0 = guests[0].documentType === 'passport';
      const rx0 = isPassport0 ? /^[A-Z0-9]{6,9}$/i : /^[A-Z0-9]{6,20}$/i;
      if (!rx0.test(doc0)) {
        newErrors.guest_0_documentNumber = isPassport0
          ? 'Passport must be 6–9 letters or digits'
          : 'ID must be 6–20 letters or digits';
      }
    }
    if (!guests[0]?.nationality) newErrors.guest_0_nationality = t("checkoutvol.required_field_error");

    // Validate doc numbers for other guests that filled one
    for (let i = 1; i < guests.length; i++) {
      const doc = String(guests[i]?.documentNumber || '').trim();
      if (!doc) continue;
      const isPassport = guests[i]?.documentType === 'passport';
      const rx = isPassport ? /^[A-Z0-9]{6,9}$/i : /^[A-Z0-9]{6,20}$/i;
      if (!rx.test(doc)) {
        newErrors[`guest_${i}_documentNumber`] = isPassport
          ? 'Passport must be 6–9 letters or digits'
          : 'ID must be 6–20 letters or digits';
      }
    }

    // Validate contact
    if (!contactData.email) newErrors.email = t("checkoutvol.invalid_email_error");
    if (!contactData.street) newErrors.street = t("checkoutvol.required_field_error");
    if (!contactData.code_postal) newErrors.code_postal = t("checkoutvol.required_field_error");
    if (!contactData.acceptedTerms) newErrors.acceptedTerms = t("checkoutvol.terms_error");

    // Validate other guests (at least name)
    guests.forEach((g, i) => {
      if (i === 0) return;
      if (!g.firstname) newErrors[`guest_${i}_firstname`] = t("checkoutvol.required_field_error");
      if (!g.lastname) newErrors[`guest_${i}_lastname`] = t("checkoutvol.required_field_error");
    });

    setErrors(newErrors);

    // Auto-expand first guest with errors
    if (Object.keys(newErrors).length > 0) {
      const guestErrorKey = Object.keys(newErrors).find(k => k.startsWith("guest_"));
      if (guestErrorKey) {
        const guestIndex = parseInt(guestErrorKey.split("_")[1], 10);
        setExpandedGuest(guestIndex);
      }
    }

    return Object.keys(newErrors).length === 0;
  };

  const submitReservation = async (token) => {
    const booker = guests[0];

    const formData = {
      nom: booker.firstname,
      surnom: booker.lastname,
      email: contactData.email,
      street: contactData.street,
      type: "VOYAGE",
      n_adult: Number(adult),
      n_enfant: Number(children),
      n_bebe: Number(bebe),
      checkin_date: checkinDate,
      checkout_date: checkoutDate,
      n_passport: booker.documentNumber,
      nationality: booker.nationality,
      code_postal: contactData.code_postal,
      acceptedTerms: contactData.acceptedTerms,
      voyage_id: voyage_id || "",
      totalAmount: Number(total),
      userId: localStorage.getItem("userId"),
      applicants: JSON.stringify(guests),
    };

    try {
      await API.post("/reservations", formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setShowReceipt(true);
      if (onComplete) onComplete();
    } catch (error) {
      const msg = error.response?.data?.message || error.response?.data?.error || "Unknown error";
      notifyError(Array.isArray(msg) ? msg.join(", ") : msg);
    }
  };

  const handlePayment = async () => {
    if (!validateForm()) {
      notifyError(isRTL ? "يرجى ملء جميع الحقول المطلوبة" : "Veuillez remplir tous les champs obligatoires");
      return;
    }
    const token = localStorage.getItem("protoken");
    if (!token) {
      setModalView("login");
      setLoginError("");
      setRegisterError("");
      setPendingPayment(true);
      setShowLoginPrompt(true);
      return;
    }
    await submitReservation(token);
  };

  const handleModalLogin = async (e) => {
    e.preventDefault();
    setLoginError("");
    setLoginLoading(true);
    try {
      const response = await API.post("/auth/login/user", loginData);
      if (response.status === 201) {
        const { token, firstname, lastname, email, id } = response.data;
        localStorage.setItem("protoken", token);
        localStorage.setItem("fullname", `${firstname} ${lastname}`);
        localStorage.setItem("email", email);
        localStorage.setItem("userId", id);
        setIsAuthed(true);
        setShowLoginPrompt(false);
        if (pendingPayment) {
          setPendingPayment(false);
          await submitReservation(token);
        }
      }
    } catch (error) {
      setLoginError(
        error.response?.data?.message ||
        (isRTL ? "خطأ في تسجيل الدخول" : "Erreur de connexion")
      );
    } finally {
      setLoginLoading(false);
    }
  };

  const handleModalRegister = async (e) => {
    e.preventDefault();
    setRegisterError("");
    if (registerData.password.length < 8) {
      setRegisterError(isRTL ? "كلمة المرور يجب أن تكون 8 أحرف على الأقل" : "Le mot de passe doit contenir au moins 8 caractères");
      return;
    }
    if (registerData.phone.length !== 10) {
      setRegisterError(isRTL ? "رقم الهاتف يجب أن يحتوي على 10 أرقام" : "Le numéro de téléphone doit contenir 10 chiffres");
      return;
    }
    setRegisterLoading(true);
    try {
      const signupRes = await API.post("/auth/signup/user", registerData);
      if (signupRes.status === 201) {
        // Auto-login after registration
        const loginRes = await API.post("/auth/login/user", {
          email: registerData.email,
          password: registerData.password,
        });
        if (loginRes.status === 201) {
          const { token, firstname, lastname, email, id } = loginRes.data;
          localStorage.setItem("protoken", token);
          localStorage.setItem("fullname", `${firstname} ${lastname}`);
          localStorage.setItem("email", email);
          localStorage.setItem("userId", id);
          setIsAuthed(true);
          setShowLoginPrompt(false);
          if (pendingPayment) {
            setPendingPayment(false);
            await submitReservation(token);
          }
        }
      }
    } catch (error) {
      setRegisterError(
        error.response?.data?.message ||
        (isRTL ? "خطأ في إنشاء الحساب" : "Erreur lors de la création du compte")
      );
    } finally {
      setRegisterLoading(false);
    }
  };

  const getGuestLabel = (guest, index) => {
    const isRTL = i18n.language === 'ar';
    if (guest.type === "ADULT") {
      const adultIndex = guests.filter((g, i2) => g.type === "ADULT" && i2 <= index).length;
      const label = isRTL ? `بالغ ${adultIndex}` : `Adulte ${adultIndex}`;
      return index === 0 ? `${label} (${isRTL ? "الرئيسي" : "Principal"})` : label;
    }
    if (guest.type === "CHILD") {
      const childIndex = guests.filter((g, i2) => g.type === "CHILD" && i2 <= index).length;
      return isRTL ? `طفل ${childIndex}` : `Enfant ${childIndex}`;
    }
    const babyIndex = guests.filter((g, i2) => g.type === "BABY" && i2 <= index).length;
    return isRTL ? `رضيع ${babyIndex}` : `B\u00e9b\u00e9 ${babyIndex}`;
  };

  const getGuestIcon = (type) => {
    if (type === "ADULT") return <FaUser />;
    if (type === "CHILD") return <FaChild />;
    return <FaBaby />;
  };

  const getGuestColor = (type) => {
    if (type === "ADULT") return "#043263";
    if (type === "CHILD") return "#e8651a";
    return "#28a745";
  };

  // Generate a PDF receipt by drawing directly with jsPDF. No html2canvas, no
  // window.print — just programmatic shapes + text so the output is deterministic.
  const handlePrintReceipt = () => {
    const booker = guests[0] || {};
    const reservationId = (voya?.id || '').slice(0, 8).toUpperCase() || 'N/A';
    const issuedAt = new Date().toLocaleString('fr-FR');
    const fmtDate = (d) => d
      ? new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
      : '-';

    const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
    const pageW = 210;
    const margin = 15;

    // ── Colors ──
    const NAVY = [4, 50, 99];
    const BLUE = [35, 158, 254];
    const ORANGE = [255, 99, 0];
    const TEXT = [17, 20, 45];
    const MUTED = [109, 114, 128];
    const BORDER = [229, 233, 242];
    const SOFT_BG = [247, 250, 255];

    // ── Header band (navy) ──
    doc.setFillColor(...NAVY);
    doc.rect(0, 0, pageW, 45, 'F');

    // Orange accent strip under header
    doc.setFillColor(...ORANGE);
    doc.rect(0, 45, pageW, 2, 'F');

    // Brand
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.text('PROTOUR TRAVEL', margin, 16);

    // Title
    doc.setFontSize(20);
    doc.text('Confirmation de reservation', margin, 26);

    // Subtitle (voyage title)
    if (voya?.title) {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setTextColor(220, 230, 245);
      doc.text(String(voya.title), margin, 34);
    }

    // Reference + issued date (right aligned)
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(220, 230, 245);
    doc.text('REFERENCE', pageW - margin, 16, { align: 'right' });
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setTextColor(255, 255, 255);
    doc.text(`#${reservationId}`, pageW - margin, 22, { align: 'right' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(220, 230, 245);
    doc.text(`Emis le ${issuedAt}`, pageW - margin, 28, { align: 'right' });

    // ── Helper to draw a section ──
    let y = 60;
    const drawSectionTitle = (label) => {
      doc.setTextColor(...NAVY);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11);
      doc.text(label, margin, y);
      // small blue underline
      doc.setDrawColor(...BLUE);
      doc.setLineWidth(0.6);
      doc.line(margin, y + 1.5, margin + 8, y + 1.5);
      y += 8;
    };

    const drawKeyValue = (label, value, col = 0) => {
      // col 0 = left half, col 1 = right half
      const colW = (pageW - margin * 2) / 2;
      const x = margin + col * colW;
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8);
      doc.setTextColor(...MUTED);
      doc.text(String(label).toUpperCase(), x, y);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setTextColor(...TEXT);
      const wrapped = doc.splitTextToSize(String(value ?? '-'), colW - 4);
      doc.text(wrapped, x, y + 5);
    };

    const rowGap = 14;

    // ── Section: Trip ──
    drawSectionTitle('Informations du voyage');
    drawKeyValue('Destination', voya?.cite || '-', 0);
    drawKeyValue('Compagnie aerienne', voya?.airline || '-', 1);
    y += rowGap;
    drawKeyValue('Date de depart', fmtDate(checkinDate), 0);
    drawKeyValue('Date de retour', fmtDate(checkoutDate), 1);
    y += rowGap;
    drawKeyValue('Hebergement', place?.name || '-', 0);
    y += rowGap;

    // Divider
    doc.setDrawColor(...BORDER);
    doc.setLineWidth(0.2);
    doc.line(margin, y, pageW - margin, y);
    y += 6;

    // ── Section: Passengers ──
    drawSectionTitle('Passagers');
    drawKeyValue('Adultes', String(Number(adult) || 0), 0);
    if (Number(children) > 0) drawKeyValue('Enfants', String(Number(children)), 1);
    y += rowGap;
    if (Number(bebe) > 0) {
      drawKeyValue('Bebes', String(Number(bebe)), 0);
      y += rowGap;
    }

    doc.setDrawColor(...BORDER);
    doc.line(margin, y, pageW - margin, y);
    y += 6;

    // ── Section: Booker ──
    drawSectionTitle('Reserve par');
    drawKeyValue('Nom complet', `${booker.firstname || ''} ${booker.lastname || ''}`.trim() || '-', 0);
    drawKeyValue('Email', contactData.email || '-', 1);
    y += rowGap;
    drawKeyValue('Passeport / ID', booker.documentNumber || '-', 0);
    drawKeyValue('Nationalite', booker.nationality || '-', 1);
    y += rowGap + 2;

    // ── Total box ──
    // Manual thousands formatter — jsPDF's default Helvetica can't render
    // the narrow no-break space that fr-FR inserts, so we format ourselves.
    const fmtAmount = (n) => {
      const v = Math.round(Number(n) || 0);
      return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };

    doc.setFillColor(...SOFT_BG);
    doc.setDrawColor(...BORDER);
    doc.setLineWidth(0.2);
    doc.roundedRect(margin, y, pageW - margin * 2, 20, 3, 3, 'FD');
    doc.setTextColor(...NAVY);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.text('MONTANT TOTAL', margin + 6, y + 12.5);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(15);
    doc.text(
      `${fmtAmount(total)} DA`,
      pageW - margin - 6,
      y + 13,
      { align: 'right' },
    );
    y += 26;

    // ── Note ──
    doc.setFillColor(255, 243, 224); // soft orange
    doc.setDrawColor(...ORANGE);
    doc.setLineWidth(0.4);
    doc.roundedRect(margin, y, pageW - margin * 2, 16, 2, 2, 'FD');
    doc.setTextColor(120, 53, 15);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    const noteLines = doc.splitTextToSize(
      "Veuillez vous rendre au bureau pour finaliser le paiement. Conservez ce recu.",
      pageW - margin * 2 - 8,
    );
    doc.text(noteLines, margin + 4, y + 6);
    y += 22;

    // ── Footer ──
    doc.setDrawColor(...BORDER);
    doc.line(margin, 282, pageW - margin, 282);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(...NAVY);
    doc.text('Protour Travel Agency', pageW / 2, 288, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(...MUTED);
    doc.text('myprotour.com', pageW / 2, 293, { align: 'center' });

    doc.save(`protour-reservation-${reservationId}.pdf`);
  };

  if (showReceipt) {
    const booker = guests[0];
    return (
      <div className={`co-section ${isRTL ? 'rtl' : ''}`}>
        <div className="co-receipt">
          <div className="co-receipt-header">
            <div className="co-receipt-check">
              <FaCheckCircle />
            </div>
            <h2>{isRTL ? "تم تأكيد حجزك!" : "R\u00e9servation confirm\u00e9e !"}</h2>
            <p className="co-receipt-sub">
              {isRTL ? "شكرا لك. إليك ملخص حجزك." : "Merci ! Voici le r\u00e9capitulatif de votre r\u00e9servation."}
            </p>
          </div>

          <div className="co-receipt-body">
            <div className="co-receipt-section">
              <h4><FaPlane /> {isRTL ? "معلومات الرحلة" : "Informations du voyage"}</h4>
              <div className="co-receipt-grid">
                <div className="co-receipt-item">
                  <span className="co-receipt-label">{isRTL ? "الوجهة" : "Destination"}</span>
                  <span className="co-receipt-value">{voya?.cite || "-"}</span>
                </div>
                <div className="co-receipt-item">
                  <span className="co-receipt-label">{isRTL ? "شركة الطيران" : "Compagnie"}</span>
                  <span className="co-receipt-value">{voya?.airline || "-"}</span>
                </div>
                <div className="co-receipt-item">
                  <span className="co-receipt-label">{isRTL ? "تاريخ المغادرة" : "D\u00e9part"}</span>
                  <span className="co-receipt-value">{checkinDate ? new Date(checkinDate).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "-"}</span>
                </div>
                <div className="co-receipt-item">
                  <span className="co-receipt-label">{isRTL ? "تاريخ العودة" : "Retour"}</span>
                  <span className="co-receipt-value">{checkoutDate ? new Date(checkoutDate).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "-"}</span>
                </div>
                <div className="co-receipt-item">
                  <span className="co-receipt-label">{isRTL ? "الإقامة" : "H\u00e9bergement"}</span>
                  <span className="co-receipt-value">{place?.name || "-"}</span>
                </div>
              </div>
            </div>

            <div className="co-receipt-section">
              <h4><FaUsers /> {isRTL ? "المسافرون" : "Passagers"}</h4>
              <div className="co-receipt-grid">
                <div className="co-receipt-item">
                  <span className="co-receipt-label">{isRTL ? "بالغين" : "Adultes"}</span>
                  <span className="co-receipt-value">{adult}</span>
                </div>
                {children > 0 && (
                  <div className="co-receipt-item">
                    <span className="co-receipt-label">{isRTL ? "أطفال" : "Enfants"}</span>
                    <span className="co-receipt-value">{children}</span>
                  </div>
                )}
                {bebe > 0 && (
                  <div className="co-receipt-item">
                    <span className="co-receipt-label">{isRTL ? "رضع" : "B\u00e9b\u00e9s"}</span>
                    <span className="co-receipt-value">{bebe}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="co-receipt-section">
              <h4><FaUser /> {isRTL ? "الحجز باسم" : "R\u00e9serv\u00e9 par"}</h4>
              <div className="co-receipt-grid">
                <div className="co-receipt-item">
                  <span className="co-receipt-label">{isRTL ? "الاسم" : "Nom"}</span>
                  <span className="co-receipt-value">{booker.firstname} {booker.lastname}</span>
                </div>
                <div className="co-receipt-item">
                  <span className="co-receipt-label">{isRTL ? "البريد" : "Email"}</span>
                  <span className="co-receipt-value">{contactData.email}</span>
                </div>
                <div className="co-receipt-item">
                  <span className="co-receipt-label">{isRTL ? "الهاتف / جواز السفر" : "Passeport"}</span>
                  <span className="co-receipt-value">{booker.documentNumber || "-"}</span>
                </div>
              </div>
            </div>

            <div className="co-receipt-total">
              <span>{isRTL ? "المبلغ الإجمالي" : "Montant total"}</span>
              <span className="co-receipt-total-value">{Number(total).toLocaleString()} DA</span>
            </div>

            <div className="co-receipt-note">
              <FaReceipt />
              <span>{isRTL ? "يرجى التوجه إلى المكتب لإتمام الدفع. احتفظ بهذا الإيصال." : "Veuillez vous rendre au bureau pour finaliser le paiement. Conservez ce re\u00e7u."}</span>
            </div>
          </div>

          <div className="co-receipt-actions">
            <button className="co-receipt-print" onClick={handlePrintReceipt}>
              <FaPrint /> {isRTL ? "تنزيل PDF" : "Télécharger PDF"}
            </button>
            <button className="co-receipt-home" onClick={() => navigate("/")}>
              <FaHome /> {isRTL ? "العودة للرئيسية" : "Retour \u00e0 l'accueil"}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`co-section ${isRTL ? 'rtl' : ''} ${!isAuthed ? 'co-locked' : ''}`}>
      <ToastContainer />

      <div className="co-layout">
        {/* Left: Guest Forms */}
        <div className="co-form-card">
          {/* Guest cards */}
          {guests.map((guest, index) => {
            const isExpanded = expandedGuest === index;
            const isBaby = guest.type === "BABY";
            const color = getGuestColor(guest.type);

            return (
              <div key={index} className={`co-guest-card ${isExpanded ? "expanded" : ""}`}>
                <div
                  className="co-guest-header"
                  onClick={() => toggleGuest(index)}
                  style={{ borderLeftColor: color }}
                >
                  <div className="co-guest-header-left">
                    <span className="co-guest-icon" style={{ background: color }}>
                      {getGuestIcon(guest.type)}
                    </span>
                    <span className="co-guest-label">{getGuestLabel(guest, index)}</span>
                    {guest.firstname && guest.lastname && (
                      <span className="co-guest-name-preview">{guest.firstname} {guest.lastname}</span>
                    )}
                  </div>
                  {isExpanded ? <FaChevronUp className="co-guest-chevron" /> : <FaChevronDown className="co-guest-chevron" />}
                </div>

                {isExpanded && (
                  <div className="co-guest-body">
                    <div className="co-form-grid">
                      {/* Name fields — all guest types */}
                      <div className="co-field co-field-half">
                        <label className="co-label">
                          <span className="co-label-icon"><FaUser /></span>
                          {t("checkoutvol.name_label")}
                        </label>
                        <input
                          className={`co-input ${errors[`guest_${index}_firstname`] ? "co-input-error" : ""}`}
                          type="text"
                          placeholder={t("checkoutvol.name_placeholder")}
                          value={guest.firstname}
                          onChange={(e) => updateGuest(index, "firstname", e.target.value)}
                        />
                        {errors[`guest_${index}_firstname`] && <span className="co-error">{errors[`guest_${index}_firstname`]}</span>}
                      </div>
                      <div className="co-field co-field-half">
                        <label className="co-label">
                          <span className="co-label-icon"><FaUser /></span>
                          {t("checkoutvol.surname_label")}
                        </label>
                        <input
                          className={`co-input ${errors[`guest_${index}_lastname`] ? "co-input-error" : ""}`}
                          type="text"
                          placeholder={t("checkoutvol.surname_placeholder")}
                          value={guest.lastname}
                          onChange={(e) => updateGuest(index, "lastname", e.target.value)}
                        />
                        {errors[`guest_${index}_lastname`] && <span className="co-error">{errors[`guest_${index}_lastname`]}</span>}
                      </div>

                      {/* Birthday — all types */}
                      <div className={`co-field ${isBaby ? "" : "co-field-half"}`}>
                        <label className="co-label">
                          <span className="co-label-icon"><FaBirthdayCake /></span>
                          {isRTL ? "تاريخ الميلاد" : "Date de naissance"}
                        </label>
                        <input
                          className="co-input"
                          type="date"
                          value={guest.birthday}
                          onChange={(e) => updateGuest(index, "birthday", e.target.value)}
                        />
                      </div>

                      {/* Gender — adults and children only */}
                      {!isBaby && (
                        <div className="co-field co-field-half">
                          <label className="co-label">
                            <span className="co-label-icon"><FaVenusMars /></span>
                            {isRTL ? "الجنس" : "Genre"}
                          </label>
                          <select
                            className="co-input"
                            value={guest.gender}
                            onChange={(e) => updateGuest(index, "gender", e.target.value)}
                          >
                            <option value="">{isRTL ? "اختر" : "S\u00e9lectionner"}</option>
                            <option value="male">{isRTL ? "ذكر" : "Homme"}</option>
                            <option value="female">{isRTL ? "أنثى" : "Femme"}</option>
                          </select>
                        </div>
                      )}

                      {/* Document fields — adults and children only */}
                      {!isBaby && (
                        <>
                          <div className="co-field co-field-half">
                            <label className="co-label">
                              <span className="co-label-icon"><FaIdCard /></span>
                              {isRTL ? "نوع الوثيقة" : "Type de document"}
                            </label>
                            <select
                              className="co-input"
                              value={guest.documentType}
                              onChange={(e) => updateGuest(index, "documentType", e.target.value)}
                            >
                              <option value="passport">{isRTL ? "جواز سفر" : "Passeport"}</option>
                              <option value="id_card">{isRTL ? "بطاقة هوية" : "Carte d'identit\u00e9"}</option>
                            </select>
                          </div>
                          <div className="co-field co-field-half">
                            <label className="co-label">
                              <span className="co-label-icon"><FaPassport /></span>
                              {t("checkoutvol.passport_label")}
                            </label>
                            <input
                              className={`co-input ${errors[`guest_${index}_documentNumber`] ? "co-input-error" : ""}`}
                              type="text"
                              placeholder={t("checkoutvol.passport_placeholder")}
                              value={guest.documentNumber}
                              onChange={(e) => updateGuest(index, "documentNumber", e.target.value)}
                            />
                            {errors[`guest_${index}_documentNumber`] && <span className="co-error">{errors[`guest_${index}_documentNumber`]}</span>}
                          </div>
                        </>
                      )}

                      {/* Nationality — adults only */}
                      {guest.type === "ADULT" && (
                        <div className="co-field">
                          <label className="co-label">
                            <span className="co-label-icon"><FaGlobe /></span>
                            {t("checkoutvol.nationality_label")}
                          </label>
                          <Select
                            styles={selectStyles}
                            options={nationalities}
                            placeholder={t("checkoutvol.nationality_placeholder")}
                            value={nationalities.find(o => o.value === guest.nationality) || null}
                            onChange={(opt) => updateGuest(index, "nationality", opt.value)}
                            menuPortalTarget={document.body}
                          />
                          {errors[`guest_${index}_nationality`] && <span className="co-error">{errors[`guest_${index}_nationality`]}</span>}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}

          {/* Contact info section */}
          <div className="co-contact-section">
            <h3 className="co-form-title">{isRTL ? "معلومات الاتصال" : "Coordonn\u00e9es"}</h3>
            <div className="co-form-grid">
              <div className="co-field">
                <label className="co-label">
                  <span className="co-label-icon"><FaEnvelope /></span>
                  {t("checkoutvol.email_label")}
                </label>
                <input
                  className={`co-input ${errors.email ? "co-input-error" : ""}`}
                  type="email"
                  name="email"
                  placeholder={t("checkoutvol.email_placeholder")}
                  value={contactData.email}
                  onChange={handleContactChange}
                />
                {errors.email && <span className="co-error">{errors.email}</span>}
              </div>
              <div className="co-field">
                <label className="co-label">
                  <span className="co-label-icon"><FaMapMarkerAlt /></span>
                  {t("checkoutvol.street_label")}
                </label>
                <input
                  className={`co-input ${errors.street ? "co-input-error" : ""}`}
                  type="text"
                  name="street"
                  placeholder={t("checkoutvol.street_placeholder")}
                  value={contactData.street}
                  onChange={handleContactChange}
                />
                {errors.street && <span className="co-error">{errors.street}</span>}
              </div>
              <div className="co-field co-field-half">
                <label className="co-label">
                  <span className="co-label-icon"><FaMailBulk /></span>
                  {t("checkoutvol.zipcode_label")}
                </label>
                <input
                  className={`co-input ${errors.code_postal ? "co-input-error" : ""}`}
                  type="text"
                  name="code_postal"
                  placeholder="16000"
                  value={contactData.code_postal}
                  onChange={handleContactChange}
                />
                {errors.code_postal && <span className="co-error">{errors.code_postal}</span>}
              </div>
            </div>

            <div className="co-terms">
              <label className="co-terms-label">
                <input
                  type="checkbox"
                  className="co-checkbox"
                  checked={contactData.acceptedTerms}
                  onChange={(e) => {
                    setContactData(prev => ({ ...prev, acceptedTerms: e.target.checked }));
                    setErrors(prev => ({ ...prev, acceptedTerms: null }));
                  }}
                />
                <span className="co-terms-text">
                  {t("checkoutvol.terms_label")}{" "}
                  <a
                    href="#privacy"
                    onClick={(e) => { e.preventDefault(); setIsPrivacyOpen(true); }}
                  >
                    {t("checkoutvol.terms_link")}
                  </a>
                </span>
              </label>
              {errors.acceptedTerms && <span className="co-error">{errors.acceptedTerms}</span>}
            </div>
          </div>
        </div>

        {/* Right: Billing Summary */}
        <div className="co-summary-card">
          {/* Trip info */}
          <div className="co-trip-info">
            <div className="co-trip-row">
              <FaPlane className="co-trip-icon" />
              <div>
                <div className="co-trip-label">{voya?.airline || "Airline"}</div>
                <div className="co-trip-sub">{voya?.cite || ""}</div>
              </div>
            </div>
            {checkinDate && (
              <div className="co-trip-dates">
                <span>{new Date(checkinDate).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" })}</span>
                <span className="co-trip-arrow">&rarr;</span>
                <span>{new Date(checkoutDate).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" })}</span>
              </div>
            )}
          </div>

          <h3 className="co-summary-title">{t("checkoutvol.billing_summary")}</h3>

          <div className="co-summary-lines">
            <div className="co-summary-line">
              <span className="co-summary-line-label">
                <FaHotel className="co-summary-line-icon" />
                {t("checkoutvol.room_price")} ({place.name})
              </span>
              <span className="co-summary-line-value">{Number(place.max_additional).toLocaleString()} DA</span>
            </div>
            <div className="co-summary-line">
              <span className="co-summary-line-label">
                <FaUsers className="co-summary-line-icon" />
                {t("checkoutvol.adults_label")} ({adult})
              </span>
              <span className="co-summary-line-value">{Number(adult * place.price).toLocaleString()} DA</span>
            </div>
            {children > 0 && (
              <div className="co-summary-line">
                <span className="co-summary-line-label">
                  <FaChild className="co-summary-line-icon" />
                  {t("checkoutvol.children_label")} ({children})
                </span>
                <span className="co-summary-line-value">{Number(children * place.price_child).toLocaleString()} DA</span>
              </div>
            )}
            {bebe > 0 && (
              <div className="co-summary-line">
                <span className="co-summary-line-label">
                  <FaBaby className="co-summary-line-icon" />
                  {t("checkoutvol.bebe_label")} ({bebe})
                </span>
                <span className="co-summary-line-value co-price-free">{isRTL ? "مجاني" : "Gratuit"}</span>
              </div>
            )}
          </div>

          <div className="co-summary-divider" />

          <div className="co-summary-total">
            <span>{t("checkoutvol.grand_total")}</span>
            <span className="co-summary-total-value">{Number(total).toLocaleString()} DA</span>
          </div>

          <div className="co-summary-actions">
            <button className="co-btn-confirm" onClick={handlePayment}>
              <FaMoneyBillWave /> {t("checkoutvol.payment_button")}
            </button>
            <button className="co-btn-back" onClick={onBack}>
              <FaArrowLeft /> {t("checkoutvol.back_button")}
            </button>
          </div>

          <div className="co-secure-note">
            <FaShieldAlt className="co-secure-icon" />
            <span>{isRTL ? "الدفع الآمن في المكتب" : "Paiement s\u00e9curis\u00e9 au bureau"}</span>
          </div>
        </div>
      </div>

      {/* Login/Register prompt overlay */}
      {showLoginPrompt && (
        <div
          className="co-login-overlay"
          onClick={() => { if (isAuthed) setShowLoginPrompt(false); }}
        >
          <div className="co-login-modal" onClick={(e) => e.stopPropagation()}>
            {isAuthed && (
              <button className="co-login-close" onClick={() => setShowLoginPrompt(false)}>
                <FaTimes />
              </button>
            )}
            <div className="co-login-icon-wrap">
              {modalView === "login" ? <FaSignInAlt /> : <FaUserPlus />}
            </div>
            <h3>{isRTL ? "خطوة أخيرة!" : "Derni\u00e8re \u00e9tape !"}</h3>
            <p>
              {modalView === "login"
                ? (isRTL ? "سجّل دخولك لتأكيد حجزك. بياناتك محفوظة." : "Connectez-vous pour confirmer votre r\u00e9servation. Vos donn\u00e9es sont conserv\u00e9es.")
                : (isRTL ? "أنشئ حسابك لتأكيد حجزك." : "Cr\u00e9ez votre compte pour confirmer votre r\u00e9servation.")}
            </p>

            {modalView === "login" ? (
              <>
                <form className="co-login-form" onSubmit={handleModalLogin}>
                  <div className="co-login-field">
                    <FaEnvelope className="co-login-field-icon" />
                    <input
                      type="email"
                      placeholder={isRTL ? "البريد الإلكتروني" : "Adresse e-mail"}
                      value={loginData.email}
                      onChange={(e) => setLoginData(prev => ({ ...prev, email: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="co-login-field">
                    <FaLock className="co-login-field-icon" />
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder={isRTL ? "كلمة المرور" : "Mot de passe"}
                      value={loginData.password}
                      onChange={(e) => setLoginData(prev => ({ ...prev, password: e.target.value }))}
                      required
                    />
                    <button type="button" className="co-login-eye" onClick={() => setShowPassword(p => !p)}>
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                  {loginError && <p className="co-login-error">{loginError}</p>}
                  <button type="submit" className="co-login-btn" disabled={loginLoading}>
                    {loginLoading
                      ? (isRTL ? "جاري التحميل..." : "Chargement...")
                      : (<><FaSignInAlt /> {isRTL ? "تسجيل الدخول وتأكيد الحجز" : "Se connecter et confirmer"}</>)}
                  </button>
                </form>
                <div className="co-login-divider">
                  <span>{isRTL ? "أو" : "ou"}</span>
                </div>
                <button className="co-register-btn" onClick={() => { setModalView("register"); setLoginError(""); }}>
                  <FaUserPlus /> {isRTL ? "إنشاء حساب جديد" : "Cr\u00e9er un compte"}
                </button>
              </>
            ) : (
              <>
                <form className="co-login-form" onSubmit={handleModalRegister}>
                  <div className="co-login-field">
                    <FaUser className="co-login-field-icon" />
                    <input
                      type="text"
                      placeholder={isRTL ? "الاسم الأول" : "Prénom"}
                      value={registerData.firstname}
                      onChange={(e) => setRegisterData(prev => ({ ...prev, firstname: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="co-login-field">
                    <FaUser className="co-login-field-icon" />
                    <input
                      type="text"
                      placeholder={isRTL ? "اللقب" : "Nom de famille"}
                      value={registerData.lastname}
                      onChange={(e) => setRegisterData(prev => ({ ...prev, lastname: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="co-login-field">
                    <FaPhone className="co-login-field-icon" />
                    <input
                      type="tel"
                      placeholder={isRTL ? "رقم الهاتف (10 أرقام)" : "Téléphone (10 chiffres)"}
                      value={registerData.phone}
                      onChange={(e) => setRegisterData(prev => ({ ...prev, phone: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="co-login-field">
                    <FaEnvelope className="co-login-field-icon" />
                    <input
                      type="email"
                      placeholder={isRTL ? "البريد الإلكتروني" : "Adresse e-mail"}
                      value={registerData.email}
                      onChange={(e) => setRegisterData(prev => ({ ...prev, email: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="co-login-field">
                    <FaLock className="co-login-field-icon" />
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder={isRTL ? "كلمة المرور (8 أحرف على الأقل)" : "Mot de passe (8 caractères min.)"}
                      value={registerData.password}
                      onChange={(e) => setRegisterData(prev => ({ ...prev, password: e.target.value }))}
                      required
                    />
                    <button type="button" className="co-login-eye" onClick={() => setShowPassword(p => !p)}>
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                  {registerError && <p className="co-login-error">{registerError}</p>}
                  <button type="submit" className="co-login-btn" disabled={registerLoading}>
                    {registerLoading
                      ? (isRTL ? "جاري التحميل..." : "Chargement...")
                      : (<><FaUserPlus /> {isRTL ? "إنشاء الحساب وتأكيد الحجز" : "Créer le compte et confirmer"}</>)}
                  </button>
                </form>
                <div className="co-login-divider">
                  <span>{isRTL ? "أو" : "ou"}</span>
                </div>
                <button className="co-register-btn" onClick={() => { setModalView("login"); setRegisterError(""); }}>
                  <FaSignInAlt /> {isRTL ? "لدي حساب بالفعل" : "J'ai déjà un compte"}
                </button>
              </>
            )}
          </div>
        </div>
      )}
      {/* ── Privacy & terms modal ───────────────────────────────── */}
      {isPrivacyOpen && (
        <div
          className="co-privacy-overlay"
          onClick={() => setIsPrivacyOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label={t("checkoutvol.privacy_terms")}
        >
          <div
            className="co-privacy-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <header className="co-privacy-head">
              <div className="co-privacy-title">
                <FaShieldAlt />
                <h2>{t("checkoutvol.privacy_terms")}</h2>
              </div>
              <button
                type="button"
                className="co-privacy-close"
                onClick={() => setIsPrivacyOpen(false)}
                aria-label="close"
              >
                <FaTimes />
              </button>
            </header>
            <div className="co-privacy-body">
              {[1, 2, 3, 4, 5].map((n) => (
                <div key={n} className="co-privacy-block">
                  <span className="co-privacy-num">{n}</span>
                  <div className="co-privacy-text">
                    <h3>{t(`checkoutvol.privacy_section_${n}_title`)}</h3>
                    <p>{t(`checkoutvol.privacy_section_${n}_content`)}</p>
                  </div>
                </div>
              ))}
            </div>
            <footer className="co-privacy-foot">
              <button
                type="button"
                className="co-privacy-accept"
                onClick={() => {
                  setContactData((prev) => ({ ...prev, acceptedTerms: true }));
                  setErrors((prev) => ({ ...prev, acceptedTerms: null }));
                  setIsPrivacyOpen(false);
                }}
              >
                <FaCheckCircle /> {t("checkoutvol.accept_terms")}
              </button>
            </footer>
          </div>
        </div>
      )}
    </div>
  );
}
